import { graphql } from "gql";

const INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_QUERY = graphql(`
  query InternalAdminUserAttributeCategory($id: [ID!]!) {
    internalAdminUserAttributeCategory(id: $id) {
      ...InternalAdminUserAttributeCategory
    }
  }
`);

export default INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_QUERY;
